import { render, staticRenderFns } from "./LocalLoader.vue?vue&type=template&id=6082d2a4&scoped=true"
import script from "./LocalLoader.vue?vue&type=script&lang=js"
export * from "./LocalLoader.vue?vue&type=script&lang=js"
import style0 from "./LocalLoader.vue?vue&type=style&index=0&id=6082d2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6082d2a4",
  null
  
)

export default component.exports